import { useSelector } from "react-redux";
import { getModule } from "store/userSlice";
import StandardEvaluatorOverview from "./EvaluatorOverview-standard";
import StateEmployeesEvaluatorOverview from "./DB/EvaluatorOverview";
import { isDbModule } from "helpers/module";

export default function EvaluatorOverview({ headerTranslation = 'global.menu.evaluation.evaluator_overview', dbHeaderTranslation, reviewerView = false, listType = null }) {
  const currentModule = useSelector(getModule);

  return (
    <>
      {
        !isDbModule(currentModule) ? <StandardEvaluatorOverview headerTranslation={headerTranslation} reviewerView={reviewerView} listType={listType} /> : <StateEmployeesEvaluatorOverview headerTranslation={dbHeaderTranslation} reviewerView={reviewerView} listType={listType} />
      }
    </>
  );
}
